<template>
  <el-dialog
    title="历史判定"
    :visible.sync="dialogVisible"
    width="80%"
    top="8vh"
    append-to-body
  >
    <div class="content_box" v-loading="loading">
      <div
        v-for="(item, index) in historyResponsibilityList"
        :key="index"
        class="responsibility_box"
      >
        <div class="responsibility_title flex_between" style="padding:10px 0">
          <span>{{ item.createTime }}</span>
          <span> 更新人：{{ item.createName }} </span>
        </div>
        <el-table :data="item.dataList" border stripe>
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="60"
          />
          <el-table-column
            prop="responsibilityType"
            label="责任类型"
            align="center"
            min-width="160px"
          >
            <template slot-scope="scope">
              {{
                getDictValueByCodeText(
                  responsibilityTypeList,
                  scope.row.responsibilityType
                )
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="responsibilityDepartment"
            label="责任部门"
            align="center"
            min-width="160px"
          >
          </el-table-column>
          <el-table-column
            prop="faultPartNumber"
            label="故障件件号"
            align="center"
            min-width="220px"
          >
          </el-table-column>
          <el-table-column
            prop="responsibilitySupplierCode"
            label="供应商代码"
            align="center"
            min-width="220px"
          >
          </el-table-column>
          <el-table-column
            prop="responsibilitySupplier"
            label="供应商名称"
            align="center"
            min-width="220px"
          >
          </el-table-column>
          <el-table-column
            prop="responsibilityRatio"
            label="责任占比"
            align="center"
            min-width="160px"
          >
            <template slot-scope="scope">
              {{ scope.row.responsibilityRatio }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="currency"
            label="货币单位"
            align="center"
            min-width="160px"
          >
            <template slot-scope="scope">
              {{ scope.row.currency === 0 ? "CNY" : "USD" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="responsibilityRemark"
            label="责任说明"
            align="center"
            min-width="160px"
          >
          </el-table-column>
        </el-table>
      </div>
      <div
        class="no_data"
        v-if="!loading && historyResponsibilityList.length === 0"
      >
        暂无数据
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getHistoryResponsibilityListApi } from "@/api/seek";
import { getDictValueByCodeText } from "@/util/dict";

export default {
  props: {
    responsibilityTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      historyResponsibilityList: []
    };
  },
  methods: {
    getDictValueByCodeText,
    async init(claimStatementId) {
      this.historyResponsibilityList = [];
      this.dialogVisible = true;
      this.loading = true;
      await this.getHistoryResponsibilityList(claimStatementId);
      this.loading = false;
    },
    // 获取历史责任
    async getHistoryResponsibilityList(claimStatementId) {
      const res = await getHistoryResponsibilityListApi({
        claimStatementId
      });
      this.historyResponsibilityList = res.data;
    }
  }
};
</script>

<style lang="scss" scoped>
.content_box {
  .no_data {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
  }
}
</style>
